import { BottomSheetModalProvider } from "@gorhom/bottom-sheet";
import type { FlashList } from "@shopify/flash-list";
/* -----------------Globals--------------- */
import { useCallback, useRef, useState } from "react";

/* -----------------Types--------------- */
import type { BaseItemSchema } from "@memorang/types/src/session/new-session";

/* -----------------Components--------------- */
import Box from "@memorang/ui/src/components/Box";
import SessionList from "./SessionList";

import { isWeb } from "@helpers/platform";
import { useAppTheme } from "@hooks/useAppTheme";
import { useDevice } from "@hooks/useDevice";
import { PassageStemModalContainer } from "../containers/PassageStemModalContainer";
import StudySessionBottombarContainer from "../containers/StudySessionBottombarContainer";
/* -----------------Containers--------------- */
import StudySessionFeedbackContainer from "../containers/StudySessionFeedbackContainer";
import { StudySessionAppBarContainer } from "./StudySessionAppBarContainer";

type Props = {
	sessionItems: BaseItemSchema[];
};
const StudySessionView = ({ sessionItems }: Props) => {
	const ref = useRef<FlashList<BaseItemSchema>>(null);
	const passageStemModalRef = useRef<{ scrollToHighlightedText: () => void }>(
		null,
	);

	const { isMobile } = useDevice();

	const [showReadMore, setShowReadMore] = useState(false);

	const toggleShowReadMore = useCallback(
		({ scrollToHighlight }: { scrollToHighlight?: boolean } = {}) => {
			if (scrollToHighlight) {
				passageStemModalRef.current?.scrollToHighlightedText();
			}
			setShowReadMore((prev) => !prev);
		},
		[],
	);

	const theme = useAppTheme();

	return (
		<Box flex={1} backgroundColor={theme.colors.background}>
			<BottomSheetModalProvider>
				<Box flex={1}>
					<StudySessionAppBarContainer />
					<Box
						flex={1}
						backgroundColor={theme.colors.surface}
						paddingTop={isMobile ? 0 : 24}
					>
						<SessionList
							ref={ref}
							items={sessionItems}
							toggleShowReadMore={toggleShowReadMore}
						/>
						{!isWeb && <StudySessionFeedbackContainer />}
					</Box>
				</Box>
			</BottomSheetModalProvider>
			<StudySessionBottombarContainer flashlistRef={ref} />
			<PassageStemModalContainer
				passageStemModalRef={passageStemModalRef}
				showReadMore={showReadMore}
				propToggleShowReadMore={() => setShowReadMore(false)}
			/>
		</Box>
	);
};

export default StudySessionView;
